import { connect } from 'react-redux'
import { arrayOf, bool, func, shape, string } from 'prop-types'
import { Link } from 'redux-little-router'
import React from 'react'
import { buildFilterClearHref } from '../../../selectors'
import { filterControlWasClicked } from '../../../actions/filter'
import Button from '../Button'
import Option from '../Option'

class MultiSelectFilter extends React.PureComponent {
  handleControlClick = () => {
    this.props.filterControlWasClicked(this.props.esKey)
  }
  handleClick = () => {
    // Do nothing
  }
  render() {
    return (
      <div className={`${this.props.className} filter`}>
        <div className="name">{this.props.name}</div>
        <Button
          handleControlClick={this.handleControlClick}
          isOpen={this.props.isOpen}
          options={this.props.options}
        />
        {this.props.isOpen &&
          <div className="panel">
            <ul>
              {this.props.options.map(option => (
                <Option
                  href={option.href}
                  isChecked={option.isChecked}
                  key={option.value}
                  name={option.name}
                  onClick={this.handleClick}
                  value={option.value}
                />
              ))}
            </ul>
            <Link
              className="clear-link"
              href={this.props.clearHref}
              onClick={this.handleControlClick}
              replaceState
            >
              Clear
            </Link>
          </div>
        }
      </div>
    )
  }
}
MultiSelectFilter.propTypes = {
  className: string.isRequired,
  clearHref: string.isRequired,
  esKey: string.isRequired,
  filterControlWasClicked: func.isRequired,
  isOpen: bool.isRequired,
  name: string.isRequired,
  options: arrayOf(shape({
    href: string.isRequired,
    isChecked: bool.isRequired,
    name: string.isRequired,
    value: string.isRequired,
  })).isRequired,
}

const mapStateToProps = (state, ownProps) => ({
  clearHref: buildFilterClearHref(state, ownProps),
  isOpen: state.filter.isOpen[ownProps.esKey],
})

export default connect(mapStateToProps, {
  filterControlWasClicked,
})(MultiSelectFilter)
